const ANIMATION_SIZE = 150;

const desktop = theme => {
  const {toVW} = theme;
  return {};
};

const mobile = theme => {
  const {toVW} = theme;
  return {
    combinationAnimationContainer: {
      position: 'absolute',
      margin: 'auto',
      minHeight: ANIMATION_SIZE,
      width: ANIMATION_SIZE,
    },
    gameResultIMG: {
      marginTop: '10px',
      height: '120px',
      width: '150px',
      objectFit: 'contain',
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
